// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-J":"J_AU_outdoor-recreation-J__L4KXN"};